import { atom, selector } from 'recoil';
import { MessageDTO } from '@/types';

/**
 * 所有面试会话的消息列表（按面试号分组）
 * 格式: { [interviewNumber]: MessageDTO[] }
 */
export const allInterviewMessagesState = atom<Record<number, MessageDTO[]>>({
  key: 'allInterviewMessagesState',
  default: {},
});

/**
 * 当前面试编号（用于过滤消息）
 */
export const currentInterviewNumberState = atom<number | null>({
  key: 'currentInterviewNumberState',
  default: null,
});

export const nextMessageIdState = atom<string | null>({
  key: 'nextMessageIdState',
  default: null,
});

export const currentWaitingReportState = atom<Record<number, 'waiting' | 'completed'> | null>({
  key: 'currentWaitingReportState',
  default: null,
});

/**
 * 当前面试会话的消息列表（根据 currentInterviewNumberState 过滤并排序）
 */
export const interviewMessagesState = selector<MessageDTO[]>({
  key: 'interviewMessagesState',
  get: ({ get }) => {
    const allMessages = get(allInterviewMessagesState);
    const currentInterviewNumber = get(currentInterviewNumberState);

    if (!currentInterviewNumber) {
      return [];
    }

    const messages = allMessages[currentInterviewNumber] || [];
    // 按照 timestamp 排序
    return [...messages].sort((a, b) => a.timestamp - b.timestamp);
  },
});

/**
 * 面试是否已禁用（结束）
 */
export const interviewDisabledState = atom<boolean>({
  key: 'interviewDisabledState',
  default: true,
});

/**
 * WebSocket 连接状态
 */
export const wsConnectedState = atom<boolean>({
  key: 'wsConnectedState',
  default: false,
});

/**
 * 需要发送确认的消息 ID（由页面组件设置，由 AppLayout 发送）
 */
export const pendingAckMessageIdState = atom<string | null>({
  key: 'pendingAckMessageIdState',
  default: null,
});
